import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { msalInstance, scopes } from '../azure/azureConfig'

import { ReactComponent as ReactWavesSvg } from '../assets/waves.svg'
import { ReactComponent as ReactLogoSvg } from '../assets/berit-exbit-logo.svg'

export const AuthorizationPage = () => {
  const {t} = useTranslation()

  const loginHandler = useCallback(() => {
    // navigates away - the response is picked up by handleRedirectPromise in App.js
    msalInstance.loginRedirect({scopes})
    .catch((error) => {
      console.error(error)
    })
  }, [])

  return (
    <section className="authorization-section">
      <div className="authorization-section__login-container">
        <div className="authorization-section__salutation">
          <ReactLogoSvg />
          <h1>{t(`authorizationPage.welcome`)}</h1>
          <span>{t(`authorizationPage.signAcc`)}</span>
        </div>
        <button className="button" onClick={loginHandler}>{t(`authorizationPage.signin`)}</button>
      </div>

      <div className="authorization-section__waves-container">
        <ReactWavesSvg />
      </div>
    </section>
  )
}